"use client";
import Image from "next/image";
import Link from "next/link";
import { AspectRatio, Box, Stack, SimpleGrid } from "@chakra-ui/react";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { CYBER_SEC_TECH_STACK_CONSTANTS } from "./constants";

const EdrMdrSecStack = () => {
  const HeadingVariant = useHeadingVariant();
  const { title, list } = CYBER_SEC_TECH_STACK_CONSTANTS;
  return (
    <Stack gap={10} mb={6}>
      <Heading variant={HeadingVariant} textAlign={"center"} px={2}>
        {title}
      </Heading>
      <SimpleGrid
        columns={{ base: 4, xl: 8 }}
        columnGap={{ base: 3, xl: 6 }}
        justifyContent={"center"}
        alignItems={"center"}
        rowGap={6}
        px={3}
        py={8}
      >
        {list.map((stack, index) => {
          return (
            <Box key={index} asChild>
              <Link href={stack.link} target="_blank" rel="noopener noreferrer">
                <AspectRatio ratio={2 / 1} key={index} position="relative" maxW="160px">
                  <Image
                    src={stack.logo}
                    alt={stack.name}
                    fill
                    style={{
                      objectFit: "contain",
                      objectPosition: "center",
                    }}
                    loading="lazy"
                  />
                </AspectRatio>
              </Link>
            </Box>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
};

export default EdrMdrSecStack;
